import { BsPerson } from "react-icons/bs";
import Input from "@/components/input/Input";
import MainDataInputs from "../../../authentication/signup/components/MainDataInputs";

function RequiredInputs({
    register,
    isPending,
    errors,
    ApiError,
    getValues,
    isRequired,
}) {
    return (
        <>
            {/* TODO:status,Image */}
            <div className="flex gap-4">
                {/* FirstName */}
                <Input
                    type="text"
                    id="firstName"
                    name="firstName"
                    disabled={isPending}
                    label="الإسم الأول*"
                    size="fullWidth"
                    icon={BsPerson}
                    register={register("firstName", {
                        ...(isRequired ? { required: isRequired } : {}),
                    })}
                    error={
                        errors?.firstName?.message ||
                        ApiError?.response?.data?.errors?.email?.[0]
                    }
                />

                {/* SecondName */}
                <Input
                    type="text"
                    name="secondName"
                    id="secondName"
                    disabled={isPending}
                    label="الإسم الثاني*"
                    size="fullWidth"
                    icon={BsPerson}
                    register={register("secondName", {
                        ...(isRequired ? { required: isRequired } : {}),
                    })}
                    error={
                        errors?.secondName?.message ||
                        ApiError?.response?.data?.errors?.email?.[0]
                    }
                />
            </div>

            <MainDataInputs
                isRequired={isRequired}
                register={register}
                isPending={isPending}
                errors={errors}
                ApiError={ApiError}
                getValues={getValues}
            />
        </>
    );
}

export default RequiredInputs;
